import React, {useState, useRef, useEffect} from 'react';
import {data} from '../utils/data';
import { useStateContext } from '../context/stateContext';

const defaultText= `&gt;_ <u>console.log(quote)</u><br/><br/>
"The more I learn, the more I realize how much I don't know,
 the less I know, the more I want to learn."<br/>
 <u>-- Someone</u><br/><br/>
<i>For Any Skill Details Click On It ...</i>
`;
const Skills = () => {
  const {lightTheme, setLinkHovred} = useStateContext();
  const consoleRef=useRef();
  const [consoleSkill, setConsoleSkill] = useState(data?.skills[0]);
  const [textToShow, setTextToShow] = useState(defaultText);
  
  let interval=null;
  // stop
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        // if the element is visible start typing in console
        let i=0;
        interval=setInterval(()=>{
          if(i!=textToShow.length){
            consoleRef.current.innerHTML=`${textToShow.slice(0,i)}|`;
            i++
          }else{
            clearInterval(interval);
          }
        }, 50)
      }else{
        consoleRef.current.innerHTML=`|`;
        clearInterval(interval);
      }
    }, { threshold: 0.5 });
    observer.observe(consoleRef.current);
    return ()=>{clearInterval(interval);observer.disconnect()};

  }, [consoleSkill, textToShow]);

  return (
    <section className={`skills-section ${lightTheme?"light":"dark"}`} id="skills">
      <div className="container">
        <h2 className='main-heading'>
          My Ski<span>ll</span>s
        </h2>
        <div className='skills-container'>
          <div className='console' ref={consoleRef}>|</div>
          <div className="skills">
            {data.skills.map((skill)=>(
              <div 
                className="skill"
                style={{backgroundColor:`${lightTheme?skill?.bg:"#FCFFE7"}`, color:"#333"}}
                key={`s_${skill?.id}`}
                onMouseLeave={()=>setLinkHovred(false)}
                onMouseEnter={()=>setLinkHovred(true)}
                onClick={()=>{
                    let theClickedSkill=data.skills.filter((s)=>s.id==skill?.id);
                    setConsoleSkill(...theClickedSkill);
                    setTextToShow(
                      // `
                      // web\\skills\\${theClickedSkill[0]?.name.toLowerCase()}&gt;_<br/><br/>{<br/><br/>
                      // <span>name :<u>${theClickedSkill[0]?.name}</u></span><br/>
                      // <span>experience :<u>${theClickedSkill[0]?.exp}</u></span><br/>
                      // <span>progress :<u>${theClickedSkill[0]?.progress} %</u></span><br/>
                      // <span>projects :<u>${theClickedSkill[0]?.projects} +</u></span><br/><br/>}
                      // `
                      `web\\skills\\${theClickedSkill[0]?.name.toLowerCase()}&gt;_<br/><br/><i>${theClickedSkill[0]?.definition}</i>`
                    );
                  }
                }
              >
                <img src={skill?.icon}/>
                <h4>{skill?.name}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Skills
